export enum PointsEventType {
  correct = "correct",
  wrong = "wrong",
  hint = "hint",
  timeBonus = "timeBonus",
  event = "event",
}

export interface PointsEventData {
  points: number;
  label?: string;
  created?: number;
  type: PointsEventType;
}
